import { converterNumeroBR } from '../lib/textoBR'

// Preco digitado na tela de precos da tabela.
//
// Aceita o formato BR ("124,20", "1.234,50", "R$ 124,20") e tambem o ponto
// decimal. Antes o campo era type="number" lido com Number(texto), que nao
// entende virgula -- e a tela mostra "atual: R$ 124,20" logo ao lado, ou seja,
// ensinava exatamente o formato que nao funcionava.
//
// null = nao ha preco a gravar (vazio, invalido ou negativo). Zero explicito e
// preco valido.
export function precoDigitado(texto: string): number | null {
  if (texto.trim() === '') return null
  const valor = converterNumeroBR(texto)
  if (valor === null || valor < 0) return null
  return valor
}

// Preco da UNIDADE SOLTA, digitado na tela da tabela de preco.
//
// ⭐ R12, decisao dela em 29/08: nesta coluna o ZERO e uma RESPOSTA -- quer
// dizer "este produto nao vende unidade solta" --, e nao um preco de R$ 0,00.
// A trava da 0021 aceita `>= 0`, entao gravar o zero como preco venderia a
// unidade solta DE GRACA.
//
// Tres respostas, e a diferenca importa porque o campo grava na SAIDA DE FOCO:
//   null      = nao vende avulso (vazio OU zero). Apaga o que estiver gravado.
//   undefined = nao consegui ler (ilegivel ou negativo). NAO mexe no gravado --
//               um dedo trocado ("6.o6") nao pode apagar o preco em silencio.
//   number    = o preco da unidade solta.
export function precoAvulsoDigitado(texto: string): number | null | undefined {
  if (texto.trim() === '') return null
  const valor = converterNumeroBR(texto)
  if (valor === null || valor < 0) return undefined
  if (valor === 0) return null
  return valor
}
